export default __webpack_public_path__ + "static/media/iconBack.9d1de936.svg";